import PropTypes from 'prop-types';

const componentDetail = {
  label: 'Customer Number Input - Phone Number',
  value: 'PhoneNumberInput',
};

const builderConfig = {
  validation: {
    minLength: {
      type: 'number',
      required: true,
      defaultValue: '10',
    },
    maxLength: {
      type: 'number',
      required: true,
      defaultValue: '13',
    },
  },
  general: {
    label: {
      type: 'string',
      required: true,
      max: { max: 40, message: `Max length is 40` },
    },
    placeholder: {
      type: 'string',
      required: false,
      max: { max: 36, message: `Max length is 36` },
    },
    hint: {
      type: 'string',
      required: false,
      max: { max: 60, message: `Max length is 60` },
    },
  },
};

const propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  hint: PropTypes.string,
  input: PropTypes.object,
  JsBridge: PropTypes.any,
  limit: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
};

const defaultProps = {
  label: 'Label',
  placeholder: window.isBizCentral ? 'Placeholder' : '',
  hint: window.isBizCentral ? 'Hint' : '',
};

export default { componentDetail, builderConfig, propTypes, defaultProps };
